import { render } from "./ProposalDeleted.vue?vue&type=template&id=5fdab7e8&scoped=true"
import script from "./ProposalDeleted.vue?vue&type=script&lang=js"
export * from "./ProposalDeleted.vue?vue&type=script&lang=js"

import "./ProposalDeleted.vue?vue&type=style&index=0&id=5fdab7e8&scoped=true&lang=css"

import exportComponent from "/go/src/bitbucket.org/VertexSecurity/spark_vuejs/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5fdab7e8"]])

export default __exports__